<template>
  <div>
    <div class="card" v-if="breadcrumbs.length">
      <div class="card-body p-2">
        <Breadcrumbs :no-use-main-page="true" :customAction="(step) => changeDirectory(step, true)"
                     :breadcrumbs="breadcrumbs"/>
      </div>
    </div>
    <div class="card" v-if="!(directoryLoaded && !directories.length)">
      <div class="card-header">Директории</div>
      <div class="card-body p-1">
        <pulse-loader :loading="loadingDirectories" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loadingDirectories && directories">
          <ul>
            <li @click="changeDirectory(d)" class="border-bottom" v-for="d in directories">
              {{ d }}
              <i class="icon-fa icon-fa-angle-right pull-right"></i>
            </li>
          </ul>
        </template>
      </div>
    </div>

    <div class="card" v-if="directoryLoaded">
      <div class="card-body p-1">
        <FilesList :path="currentFolder"/>
      </div>
    </div>
  </div>
</template>

<script>

import FilesList from "@/views/fileStorage/s3/components/FilesList.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import api from "@/api";

export default {
  components: {
    Breadcrumbs,
    FilesList,
  },
  data() {
    return {
      loadingDirectories: false,
      loadingFiles: false,
      directoryLoaded: false,
      currentFolder: '/',
      directories: null,
      files: null,
      breadcrumbs: []
    }
  },
  created() {
    this.getDirectories();
  },
  methods: {
    changeDirectory(d, byBreadcrumbs = false) {
      if (byBreadcrumbs) {
        if (d.path === '/') {
          this.breadcrumbs = [];
          this.currentFolder = '/';
          this.getDirectories();
          return;
        }
        let current = false;
        let currentDirectory = '';
        const steps = this.breadcrumbs.reduce((acc, s) => {
          if (current) return acc;
          currentDirectory += (s.path + (s.path === '/' ? '' : '/'));
          if (s.title === d.title) current = true;
          acc.push(s);
          return acc;
        }, []);
        this.breadcrumbs = steps;
        this.currentFolder = currentDirectory;
      } else {
        if (!this.breadcrumbs.length) {
          this.breadcrumbs.push({title: 'Root', path: '/'});
        }
        this.breadcrumbs.push({title: d, path: d});
        this.currentFolder += (d + '/')
      }
      this.getDirectories()
    },
    async getDirectories() {
      this.loadingDirectories = true;
      this.directoryLoaded = false;
      const {data} = await api.post('/filestorage/list', {
        action: 'directories',
        path: this.currentFolder
      })
      if (data.success) {
        this.directories = (data.records || []).reduce((acc, r) => {
          const d = r.Prefix.slice(0, -1).split('/').pop();
          acc.push(d);
          return acc;
        }, []);
        this.directoryLoaded = true;
      }
      this.loadingDirectories = false;
    }
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  padding: 0 10px;
}

ul li i {
  margin-top: 4px;
}

ul li {
  padding: 3px 0;
}
</style>
